import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import Tr from '../../../../../../components/common-table/components/Tr';
import Td from '../../../../../../components/common-table/components/Td';
import CommonIconButton from '../../../../../../components/common-icon-button/CommonIconButton';
import { ICONS } from '../../../../../../icons';

import scss from '../AgentList.module.scss';

function AgentTableItem({ agent, onDelete, onPreview }) {
  const navigate = useNavigate();
  const { t } = useTranslation('settings');

  const { id, count, name, instructions } = agent;

  const handleEditWriter = () => {
    navigate(`edit-agent/${id}`);
  };

  const handlePreview = () => {
    onPreview(agent);
  };

  const handleDelete = () => {
    onDelete(agent);
  };

  return (
    <Tr>
      <Td extraClasses='cell-rank'>{count}</Td>
      <Td extraClasses={scss.cellName} isLeft>
        {name}
      </Td>
      <Td isLeft extraClasses={scss.cellInstructions}>
        <span>{instructions}</span>
      </Td>
      <Td extraClasses={scss.cellAction} isLeft>
        <CommonIconButton icon={ICONS.Edit} onClick={handleEditWriter} color='inherit' tooltip={t('edit')} />
        <CommonIconButton
          icon={ICONS.Info}
          isStrokeIcon
          onClick={handlePreview}
          color='inherit'
          tooltip={t('preview')}
        />

        <CommonIconButton icon={ICONS.Delete} onClick={handleDelete} color='inherit' tooltip={t('delete')} />
      </Td>
    </Tr>
  );
}

export default AgentTableItem;
